import React, {useState} from "react";
import { Table } from "antd";
import { useSelector } from "react-redux";
import _ from "lodash";
import dayjs from "dayjs";

const fmt = (num) =>
  Number(num || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const ContraRecordTable = ({ printMode = false }) => {
  const { list, listWithDetails, filters, loading } = useSelector(
    (state) => state.contraRecord
  );
    const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  let dataSource =
    filters.recordType === "with details" ? listWithDetails : list;

  let columns =
    filters.recordType === "with details"
      ? [
          { title: "No.", render: (_, __, idx) => idx + 1 },
          { title: "VCH", dataIndex: "con_code" },
          {
            title: "Date",
            dataIndex: "created_date",
            render: (date) => dayjs(date).format("DD MMM YYYY"),
          },
          { title: "Customer", dataIndex: "acc_name" },
          { title: "Receipt By", dataIndex: "full_name" },
          {
            title: "Details",
            dataIndex: "details",
            render: (details) => (
              <>
                {details.map((d, i) => (
                  <div
                    key={i}
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <span>{d.into_acc_name}</span>
                    <span>{fmt(d.con_total)}</span>
                  </div>
                ))}
                <strong>Total: {fmt(_.sumBy(details, "con_total"))}</strong>
              </>
            ),
          },
        ]
      : [
          { title: "No.", render: (_, __, idx) => idx + 1 },
          { title: "VCH No", dataIndex: "contra_code" },
          {
            title: "Date",
            dataIndex: "created_date",
            render: (date) => dayjs(date).format("DD MMM YYYY"),
          },
          { title: "From Account", dataIndex: "from_acc_name" },
          { title: "To Account", dataIndex: "to_acc_name" },
          { title: "Receipt By", dataIndex: "full_name" },
          {
            title: "Amount",
            dataIndex: "tran_amount",
            align: "right",
            render: fmt,
          },
        ];

  const grandTotal =
    filters.recordType === "with details"
      ? _.sumBy(listWithDetails, (r) => _.sumBy(r.details, "con_total"))
      : _.sumBy(list, (r) => Number(r.tran_amount) || 0);
  
  if (printMode) {
  const isWithDetails = filters.recordType === "with details";

  return (
    <table className="contra-print-table">
      <tbody>
        <tr className="contra-print-heading">
          {isWithDetails ? (
            <>
              <td>No.</td>
              <td>VCH</td>
              <td>Date</td>
              <td>Customer</td>
              <td>Receipt By</td>
              <td>Details</td>
            </>
          ) : (
            <>
              <td>No.</td>
              <td>VCH No</td>
              <td>Date</td>
              <td>From Account</td>
              <td>To Account</td>
              <td>Receipt By</td>
              <td>Amount</td>
            </>
          )}
        </tr>

        {isWithDetails
          ? listWithDetails.map((row, index) => (
              <tr key={row.id || index}>
                <td>{index + 1}</td>
                <td>{row.con_code}</td>
                <td>{dayjs(row.created_date).format("DD MMM YYYY")}</td>
                <td>{row.acc_name}</td>
                <td>{row.full_name}</td>

                <td>
                  {row.details?.map((d, i) => (
                    <div
                      key={i}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span>{d.into_acc_name}</span>
                      <span>{fmt(d.con_total)}</span>
                    </div>
                  ))}

                  <div style={{ fontWeight: 700 }}>
                    Total : {fmt(_.sumBy(row.details, "con_total"))}
                  </div>
                </td>
              </tr>
            ))
          : list.map((row, index) => (
              <tr key={row.id || index}>
                <td>{index + 1}</td>
                <td>{row.contra_code}</td>
                <td>{dayjs(row.created_date).format("DD MMM YYYY")}</td>
                <td>{row.from_acc_name}</td>
                <td>{row.to_acc_name}</td>
                <td>{row.full_name}</td>
                <td style={{ textAlign: "right" }}>
                  {fmt(row.tran_amount)}
                </td>
              </tr>
            ))}

        <tr className="contra-print-total">
          <td
            colSpan={isWithDetails ? 5 : 6}
            style={{ textAlign: "right" }}
          >
            Grand Total :
          </td>

          <td style={{ textAlign: "right" }}>
            {fmt(grandTotal)}
          </td>
        </tr>
      </tbody>
    </table>
  );
}

  return (
    <Table
      rowKey={(record, idx) => record.id || idx}
      columns={columns}
      dataSource={dataSource}
      loading={loading}
       pagination={{
        ...pagination,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50"],
      }}
      onChange={handleTableChange}
      bordered
      summary={() => (
        <Table.Summary.Row>
          <Table.Summary.Cell colSpan={columns.length - 1} align="right">
            <strong>Grand Total :</strong>
          </Table.Summary.Cell>
          <Table.Summary.Cell align="right">
            <strong>{fmt(grandTotal)}</strong>
          </Table.Summary.Cell>
        </Table.Summary.Row>
      )}
    />
  );
};

export default ContraRecordTable;
